import UserDetailsPage from "@/systems/identity/UserDetailsPage.vue";
import UserJoinedCommunitiesPage from "@/systems/identity/UserJoinedCommunitiesView.vue";
import {RouterView} from "vue-router";
import authorization from "@/authorization";
import {adminRoles} from "@/systems/main/adminRoles";
import UsersPage from "@/systems/admin/UsersView.vue";
import UserHeaderView from "@/systems/identity/UserHeaderView.vue";
import info from "@/info";
import UserCommunityInviteView from "@/systems/identity/UserCommunityInviteView.vue";

export default [
    {
        name: "users",
        path: "users",
        component: RouterView,
        redirect: { name: "users.list" },
        children: [
            {
                name: "users.list",
                path: "list",
                component: UsersPage,
                meta: {
                    authorize: () => authorization.adminRole(adminRoles.moderator)
                }
            },
            {
                name: "user",
                path: ":userId",
                component: UserHeaderView,
                props: true,
                redirect: { name: "user.details" },
                children: [
                    {
                        name: "user.details",
                        path: "details",
                        component: UserDetailsPage,
                        props: true
                    },
                    {
                        path: "communities",
                        name: "user.communities",
                        component: UserJoinedCommunitiesPage,
                        props: true
                    },
                ]
            },
            {
                name: "user.me",
                path: "me",
                redirect: () => ({ name: "user", params: { userId: info.user?.id } }),
                children: [
                    {
                        name: "user.me.communities",
                        path: "communities",
                        redirect: () => ({ name: "user.communities", params: { userId: info.user?.id } }),
                    }
                ]
            },
            {
                path: "communities/invites/:token",
                name: "users.communities.invite",
                component: UserCommunityInviteView,
                props: true
            },
        ]
    },
]